// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"16bcd253","497":"9c659a26","578":"ce35cf02","705":"8511fa9e","722":"71f21ed0","778":"9b220cd4","884":"0f168591"}[chunkId] + ".chunk.js";
};